import { render, staticRenderFns } from "./game-background.vue?vue&type=template&id=ea277ca2&scoped=true&"
import script from "./game-background.vue?vue&type=script&lang=js&"
export * from "./game-background.vue?vue&type=script&lang=js&"
import style0 from "./game-background.vue?vue&type=style&index=0&id=ea277ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea277ca2",
  null
  
)

export default component.exports